import React,{useState} from "react";
import { useWeather} from "./hooks/useWeather";
import{Search,MapPin,Wind,Droplets,CloudSun}from"lucide-react"; 
import './App.css';

function App() {
  const [city,setCity]=useState('');
  const{data,loading,error,fetchWeather}=useWeather();
  const handleSearch=(e)=>{
    e.preventDefault();
    if(city) fetchWeather(city);
  }
  return (
  <div className="app-container">
    <header className="weather-header">
      <CloudSun size={48} className="header-icon" />
      <div className="header-text">
        <h1>Weather Report</h1>
        <p>Live Meteorological Insights</p>
      </div>
    </header>

    <form onSubmit={handleSearch} className="search-bar">
      <input 
        type="text" 
        placeholder="Search for a city..." 
        value={city}
        onChange={(e) => setCity(e.target.value)}
      />
      <button type="submit"><Search size={22} /></button>
    </form>

    {loading && <div className="loader">Analyzing atmosphere...</div>}
    {error && <div className="error-msg">{error}</div>}

    {data && (
      <div className="weather-card">
        <div className="main-info">
          <div className="location">
            <MapPin size={20} />
            <span>{data.name}, {data.sys.country}</span>
          </div>
          <div className="temp-display">
            <h1>{Math.round(data.main.temp)}°C</h1>
            <p>{data.weather[0].description}</p>
          </div>
        </div>

        <div className="stats-grid">
          <div className="stat-tile">
            <Droplets size={24} color="#06b6d4" />
            <div className="stat-info">
              <span>{data.main.humidity}%</span>
              <label>Humidity</label>
            </div>
          </div>
          <div className="stat-tile">
            <Wind size={24} color="#8b5cf6" />
            <div className="stat-info">
              <span>{data.wind.speed} m/s</span>
              <label>Wind</label>
            </div>
          </div>
        </div>
      </div>
    )}
  </div>
);}
export default App;
